@import 'styles/mixins';
@import 'styles/variables';

.loadingIcon {
  background: conic-gradient(
    from 90deg at 50% 50%,
    rgba(143, 152, 169, 0) 0deg,
    $grey-30 359.96deg,
    rgba(143, 152, 169, 0) 360deg
  );

  &.dark {
    background: conic-gradient(
      from 90deg at 50% 50%,
      rgba(143, 152, 169, 0) 0deg,
      #2b2f38 359.96deg,
      rgba(143, 152, 169, 0) 360deg
    );
  }

  &.blue {
    background: conic-gradient(from 90deg at 50% 50%, #d7eefc 0deg, #069bf7 359.96deg, #d7eefc 360deg);
  }

  &.transparent {
    background: conic-gradient(
      from 90deg at 50% 50%,
      rgba(255, 255, 255, 0) 0deg,
      rgba(255, 255, 255, 1) 359.96deg,
      rgba(255, 255, 255, 0) 360deg
    );
    mask-image: radial-gradient(transparent 45%, black 55%);
    -webkit-mask-image: radial-gradient(transparent 45%, black 55%);

    &:after {
      display: none;
    }
  }

  height: 15px;
  width: 15px;
  border-radius: 50%;
  position: relative;
  animation: spin 1600ms linear infinite;

  &:after {
    content: '';
    position: absolute;
    height: 9px;
    width: 9px;
    background: var(--neutral-0);
    border-radius: 50%;
    top: 3px;
    left: 3px;
  }

  &.large {
    height: 32px;
    width: 32px;
    &:after {
      height: 19px;
      width: 19px;
      top: 6.5px;
      left: 6.5px;
    }
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
